export const AUTHORIZATION_JWT = 'authorizationJwt';
export const SHORT_TEXT = 'SHORT_TEXT';
export const LONG_TEXT = 'LONG_TEXT';
export const LONG_TEXT_FILE_UPLOAD = 'LONG_TEXT_FILE_UPLOAD';
export const MULTIPLE_CHOICE_CHECKBOX = 'MULTIPLE_CHOICE_CHECKBOX';
export const MULTIPLE_CHOICE_RADIO = 'MULTIPLE_CHOICE_RADIO';
export const FILL_IN_THE_GAP = 'FILL_IN_THE_GAP';
